﻿/* 
Object:         Account
Description:    Login logic for the login page and account page / pane.
Used in:        Login page and account page (change language)
*/

/*---[ ESLint ]---*/
/*
    global account
*/

window.account = function () {

    return {
        Initialize_Login: function () {
            // Create new record ...
            $("#bttn-login").click(function (e) {

                // Prevent default behaviour
                e.preventDefault();
                account.SubmitLogin();

            });

            // Create new record ...
            $("#bttn-forgotpassword").click(function (e) {

                // Prevent default behaviour
                e.preventDefault();
                account.NavigateToForgotPassword();

            });

            $("#UserName").keyup(function (event) {
                if (event.keyCode == '13') {
                    account.SubmitLogin();
                    $("#UserName").blur();
                }
            });

            $("#Password").keyup(function (event) {
                if (event.keyCode == '13') {
                    account.SubmitLogin();
                    $("#Password").blur();
                }
            });
        },

        SetPasswordEditor: function (container, options) {
            $('<input type="password" id="Password" name="' + options.field + '" title="Password" required="required" autocomplete="off" aria-labelledby="Password-form-label" data-bind="value: Password" aria-describedby="Password-form-hint"/>')
                .appendTo(container)
                .kendoTextBox();
        },

        OnFormValidateField: function (e) {
            $("#validation-success").html("");
        },

        OnFormSubmit: function (e) {

        },

        OnFormClear: function (e) {
            $("#validation-success").html("");
        },

        OnForm_ResetPassword_Submit: function (e) {

        },

        OnForm_ResetPassword_Clear: function (e) {
            $("#validation-success").html("");
        },

        OnForm_ResetPassword_ValidateField: function (e) {
            $("#validation-success").html("");
        },

        NavigateToLogin: function () {
            window.location.assign(appsettings.getUrl("Account/Login"));
        },

        NavigateToForgotPassword: function () {
            window.location.assign(appsettings.getUrl("Account/ForgotPassword"));
        },

        SubmitLogin: function () {
            form.submitForm("frmLogin", "Account/PostLogin", false, null);
        },

        OnChangeLanguageSetting: function (element) {

            var selected_culture = $("#cultureSetting").val();

            // change on client side browser
            switch (selected_culture) {
                case "nl-NL":
                    //require("@progress/kendo-ui/js/messages/kendo.messages.nl-NL")
                    break;
                case "en-EN":
                    //require("@progress/kendo-ui/js/messages/kendo.messages.en-US")
                    break;
                case "de-DE":
                    //require("@progress/kendo-ui/js/messages/kendo.messages.de-DE")
                    break;

            }

            element.form.submit();
        },

        RedirectToExternalIdentityProvider: function (identityProviderId, returnUrl) {

            //Set cookie auto login with SSO
            account.SetLoginCookie("UseExternalLoginAutomatic", true, 365);

            //Usage IdentityProvider and ReturnUrl (for future use).
            account.SetLoginCookie("UseExternalLoginAutomaticIdentityProviderId", identityProviderId, 365);
            account.SetLoginCookie("UseExternalLoginAutomaticIdentityReturnUrl", returnUrl, 365);

            // redirect
            location.href = appsettings.getUrl('Auth/ExternalLogin?identityProviderId=' + identityProviderId + '&returnUrl=' + returnUrl);
        },

        ///
        /// Set Login Cookie 
        ///
        SetLoginCookie: function (cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        },
    }
}();